export default __webpack_public_path__ + "static/media/basketBall_p2.5066b9ed.jpg";